import { getFiltersToFeatures, getIsCheckedAll } from '@/redux/features/selectors';
import { useSelector } from 'react-redux';

export const useFeaturesFilter = () => {
  const filtersToFeatures = useSelector(getFiltersToFeatures);
  const isCheckedAll = useSelector(getIsCheckedAll);

  return { filtersToFeatures, isCheckedAll };
};
